import {
  CalendarOutlined,
  DashboardOutlined,
  EditOutlined,
  FileTextOutlined,
  LockOutlined,
  LogoutOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Button, Col, Menu, Row, Skeleton } from "antd";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import { Company } from "interfaces/company";
import { Link, NavLink, useLocation } from "react-router-dom";

interface Props {
  company: Company;
}
// const { Text } = Typography;

export const NavMenu: React.FC<Props> = ({ company }) => {
  const { logOut } = useLoginContext();

  const menuKeyMap = {
    "/company/company-profile/edit-profile/": "2",
    "/company/company-profile/events/": "3",
    "/company/company-profile/jobs/": "4",
    "/company/company-profile/contact-persons/": "5",
    "/company/company-profile/account/": "6",
    "/company/company-profile/": "1",
  };

  const location = useLocation();
  const selectedKey =
    menuKeyMap[
      Object.keys(menuKeyMap).find((path): path is keyof typeof menuKeyMap => location.pathname.startsWith(path)) ||
        "/company/company-profile/"
    ]; // Default 1

  const getIconStyle = (key: string) => ({
    color: selectedKey === key ? "white" : "inherit", // Change color to blue for active items
  });

  return (
    <Row gutter={[0, 48]} style={{ overflow: "hidden" }}>
      <Col
        span={24}
        style={{
          marginTop: "50px",
          height: "100px",
          width: "100%",
          padding: "2em",
        }}
      >
        {company ? (
          <CompanyLogo
            size="70%"
            companyId={company.id}
            src={company.logo.includes("http") ? company.logo : `${process.env.REACT_APP_API_URL}/${company.logo}`}
          />
        ) : (
          <Skeleton.Image />
        )}
      </Col>

      <Col style={{ width: "99.8%" }}>
        <Menu mode="inline" selectedKeys={[selectedKey]} style={{ height: "100%", border: "none" }}>
          <Menu.Item key="1" icon={<DashboardOutlined style={getIconStyle("1")} />}>
            <NavLink exact to="/company/company-profile/" activeStyle={{ color: "white" }}>
              Min oversikt
            </NavLink>
          </Menu.Item>
          <Menu.Item key="2" icon={<EditOutlined style={getIconStyle("2")} />}>
            <NavLink to="/company/company-profile/edit-profile/" activeStyle={{ color: "white" }}>
              Rediger bedriftsprofil
            </NavLink>
          </Menu.Item>
          <Menu.Item key="3" icon={<CalendarOutlined style={getIconStyle("3")} />}>
            <NavLink to="/company/company-profile/events/" activeStyle={{ color: "white" }}>
              Mine arrangementer
            </NavLink>
          </Menu.Item>
          <Menu.Item key="4" icon={<FileTextOutlined style={getIconStyle("4")} />}>
            <NavLink to="/company/company-profile/jobs/" activeStyle={{ color: "white" }}>
              Mine stillingsannonser
            </NavLink>
          </Menu.Item>
          <Menu.Item key="5" icon={<TeamOutlined style={getIconStyle("5")} />}>
            <NavLink to="/company/company-profile/contact-persons/" activeStyle={{ color: "white" }}>
              Mine kontaktpersoner
            </NavLink>
          </Menu.Item>
          <Menu.Item key="6" icon={<LockOutlined style={getIconStyle("6")} />}>
            <NavLink to="/company/company-profile/account/" activeStyle={{ color: "white" }}>
              Kontoinnstillinger
            </NavLink>
          </Menu.Item>
        </Menu>
      </Col>
      <Col
        span={24}
        style={{ paddingLeft: "24px", paddingRight: "24px", position: "absolute", width: 270, bottom: 30 }}
      >
        <Link
          to="/"
          onClick={() => {
            logOut();
          }}
        >
          <Button type="text" style={{ width: "100%", color: "grey" }}>
            <LogoutOutlined /> Logg ut
          </Button>
        </Link>
      </Col>
    </Row>
  );
};
